import * as React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type StatusBadgeVariant = 'success' | 'warning' | 'danger' | 'info';

const VARIANT_CLASS: Record<StatusBadgeVariant, string> = {
  success:
    'bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20',
  warning:
    'bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20',
  danger: 'bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20',
  info: 'bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20',
};

export interface StatusBadgeProps {
  variant: StatusBadgeVariant;
  children: React.ReactNode;
  className?: string;
}

export function StatusBadge({
  variant,
  children,
  className,
}: StatusBadgeProps): JSX.Element {
  return (
    <Badge variant="outline" className={cn(VARIANT_CLASS[variant], className)}>
      {children}
    </Badge>
  );
}
